import React from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import CommonMessage from './../commonMessage';
import { ResourceService } from './../../../services/resource.service';
import ScrollArea from 'react-scrollbar';

export default class LeftNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            roleId: localStorage.getItem("roleId"),
            isUserSubscribed: false,
            isSettings: false,
            maxSidebarMenuHeight: document.getElementsByClassName("logo")?.item(0)?.scrollHeight ? window.innerHeight - document.getElementsByClassName("logo")?.item(0)?.scrollHeight - 32 : window.innerHeight - 154,
            minScrollSize: 10,
            scrollBarOpacity: "0",
            scrollY: 0,
        };
        this.scrollRef = React.createRef();
        this.checkForSubscription = this.checkForSubscription.bind(this);
    }

    componentDidMount() {
        $('.rhs-nav-icons .stats_info_icon').click(function () {
            $('.main_slider, .rhs_slide_ntwkStats').addClass('active');
            $('body').addClass('no_scroll');
        });
        $('.main_slider_container .close_icon').click(function () {
            $('.main_slider').removeClass('active');
            $('body').removeClass('no_scroll');

        });
        window.addEventListener("resize", this.refreshScrollBar, true);
        this.setState({
            maxSidebarMenuHeight: document.getElementsByClassName("logo")?.item(0)?.scrollHeight ? window.innerHeight - document.getElementsByClassName("logo")?.item(0)?.scrollHeight - 32 : window.innerHeight - 154
        });
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.refreshScrollBar, true);
    };

    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    message: "Error while getting user subscription details",
                    msgType: "error"
                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isSettings: true
                });
            }
            else {
                this.setState({
                    isSettings: false
                });
            }

        }).catch(error => {
            this.setState({
                message: "Error while getting user subscription details",
                msgType: "error"
            });
        });
    };


    reload() {
        let geturl = window.location.pathname;
        if(geturl === "/app/index") {
            window.location.reload();
        }
    }

    refreshScrollBar = (event) => {
        this.scrollTop();
        this.setState({
            maxSidebarMenuHeight: document.getElementsByClassName("logo")?.item(0)?.scrollHeight ? window.innerHeight - document.getElementsByClassName("logo")?.item(0)?.scrollHeight - 32 : window.innerHeight - 154
        });
    };

    scrollBarFocusHandler = (event) => {
        let opacity;
        if(event.type === 'mouseenter') {
            opacity = "0.5";
        } else if(event.type === 'mouseleave') {
            opacity = "0";
        }
        this.setState({
            scrollBarOpacity: opacity
        });
    };

    scrollTop = (event) => {
        if(this.scrollRef && this.scrollRef.current && this.scrollRef.current.scrollArea) {
            this.scrollRef.current.scrollArea.scrollTop();
        }
    };

    render() {
        return (
            <nav className="left_sidebar_wrap new_menu">
                <div className="left_sidebar">
                    <a href="https://www.idrivecompute.com" target="_blank">
                        <div className="logo" >
                            <div className="icon">
                            </div>
                        </div>
                    </a>
                    <div className="sidebar_menu" onMouseEnter={ event => this.scrollBarFocusHandler(event) } onMouseLeave={ event => this.scrollBarFocusHandler(event) }>
                        <div id="scrollAreaSidebar" >
                            <ScrollArea ref={ this.scrollRef }
                                className="sidebar_menu_scroll"
                                speed={ 0.5 }
                                vertical={ true }
                                horizontal={ false }
                                minScrollSize={ this.state.minScrollSize }
                                smoothScrolling={ true }
                                verticalScrollbarStyle={ { backgroundColor: "#FFFFFF", opacity: this.state.scrollBarOpacity, transition: 'ease-in-out 50ms' } }
                                verticalContainerStyle={ { backgroundColor: "#FFFFFF", opacity: this.state.scrollBarOpacity, transition: 'ease-in-out 50ms' } }
                                stopScrollPropagation={ true }
                            >
                                <ul className="sidebar_menu_ul">
                                    <li className="sm_instance">
                                        <Link to={ this.state.isUserSubscribed ? "/billing/creditcard" : "/index" } className={ this.props.isActive === 'instances' ? 'active' : {} } onClick={ this.reload }>
                                            <span className="icon"></span>
                                            <span className="item">Instances</span>
                                        </Link>
                                    </li>
                                    <li className="sm_ssh_key" >
                                        <Link to={ this.state.isUserSubscribed ? "/billing/creditcard" : "/ssh-key" } className={ this.props.isActive === 'sshkey' ? 'active' : {} }>
                                            <span className="icon"></span>
                                            <span className="item">SSH Keys</span>
                                        </Link>
                                    </li>
                                    <li className="sm_firewall" >
                                        <Link to={ this.state.isUserSubscribed ? "/billing/creditcard" : "/firewall" } className={ this.props.isActive === 'firewall' ? 'active' : "" }>
                                            <span className="icon"></span>
                                            <span className="item">Firewalls</span>
                                        </Link>
                                    </li>
                                    <li className="sm_volume" >
                                        <Link to={ this.state.isUserSubscribed ? "/billing/creditcard" : "/volumes" } className={ this.props.isActive === 'volumes' ? 'active' : "" }>
                                            <span className="icon"></span>
                                            <span className="item">Volumes</span>
                                        </Link>
                                    </li>
                                    <li className="sm_lb">
                                        <Link to={ this.state.isUserSubscribed ? "/billing/creditcard" : "/load-balancers" } className={ this.props.isActive === 'loadbal' ? 'active' : "" } >
                                            <span className="icon"></span>
                                            <span className="item">Load<br></br> Balancers</span>
                                        </Link>
                                    </li>
                                    <li className="sm_image" >
                                        <Link to={ this.state.isUserSubscribed ? "/billing/creditcard" : "/images" } className={ this.props.isActive === 'images' ? 'active' : "" }>
                                            <span className="icon"></span>
                                            <span className="item">Images</span>
                                        </Link>
                                    </li>
                                    { this.state.roleId === '2' ?
                                        <li className="sm_myusers">

                                            <Link to={ this.state.isUserSubscribed ? "/billing/creditcard" : "/users" } className={ this.props.isActive === 'users' ? 'active' : "" }>
                                                <span className="icon"></span>
                                                <span className="item">Users</span>
                                            </Link>

                                        </li> : "" }
                                    { this.state.roleId === '2' ?
                                        <li className="sm_billing">
                                            <Link to="/billing/creditcard" className={ this.props.isActive === 'billing' ? 'active' : "" }>
                                                <span className="icon"></span>
                                                <span className="item">Billing</span>
                                            </Link>
                                        </li> : "" }
                                    <li className="sm_activitylogs">
                                        <Link to={ this.state.isUserSubscribed ? "/billing/creditcard" : "/web-activity" } className={ this.props.isActive === 'logs' ? 'active' : "" }>
                                            <span className="icon"></span> <span className="item">Activity Logs</span>
                                        </Link>
                                    </li>
                                    { this.state.roleId === '2' ?
                                        <li className="sm_settings">
                                            <Link to="/settings-main" className={ this.props.isActive === 'settings' ? 'active' : "" }>
                                                <span className="icon"></span>
                                                <span className="item">Settings</span>
                                            </Link>
                                        </li> : "" }
                                    {/* { this.state.roleId === '2' ?
                                        <li className="sm_referral">
                                            <Link to="/referral/referral_linking_code" className={ this.props.isActive === 'referral' ? 'active' : "" }>
                                                <span className="icon"></span>
                                                <span className="item">Referral</span>
                                            </Link>
                                        </li> : "" } */}
                                    <li className="sm_myaccount" >
                                        <Link className={ this.props.isActive === 'account' ? 'active' : "" } to="/account/profile">
                                            <span class="icon"></span>
                                            <span class="item">My Account</span>
                                        </Link>
                                    </li>

                                </ul>

                            </ScrollArea>
                        </div>
                    </div>

                    <div className="sidebar_video_wrap" style={ { zIndex: 99 } }>
                        <div className="sidebar_brand">
                            <p>© IDrive Inc.</p>
                        </div>
                    </div>
                </div>
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } handler={ () => this.setState({ message: '' }) } />
            </nav>
        );
    }
}